module.exports = __webpack_public_path__ + "img/inform.c154d766.svg";